import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_endOrderNextPage, fn_endOrderPrevPage} from "../../../function/FnBodyEndOrder";

@observer
class EndOrderPagingBottomView extends Component {
    render() {

        const { rootStore } = this.props;
        const endOrderStore = rootStore.endOrderStore;


        return (
            <div className="paging">
                <button type="button" className="prev" disabled={endOrderStore.getEndOrderPaging.end_page_no === 1 ? "disabled" : ""}
                    onClick={(evnet)=>fn_endOrderPrevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{endOrderStore.getEndOrderPaging.end_page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {endOrderStore.getEndOrderPaging.end_max_page}
                </p>
                <button type="button" className="next" disabled={endOrderStore.getEndOrderPaging.end_page_no === endOrderStore.getEndOrderPaging.end_max_page ? "disabled" : ""}
                        onClick={(evnet)=>fn_endOrderNextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default EndOrderPagingBottomView;